export const price = [
    { "name": "Below €10 ", "min": 0, "max": 10, "value": "0 - 10" },
    { "name": "€10 - €50", "min": 10, "max": 50, "value": "10 - 50" },
    { "name": "€50 - €100", "min": 50, "max": 100, "value": "50 - 100" },
    { "name": "€100 - €300", "min": 100, "max": 300, "value": "100 - 300" },
    { "name": "€300 - €500", "min": 300, "max": 500, "value": "300 - 500" },
    { "name": "€500 and above", "min": 500, "max": null, "value": "500" }
  ];
  